import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import AccountProfileComponent from './js/account-profile.component';

ComponentsFactory.getInstance().define('account-profile', AccountProfileComponent);
